export default __webpack_public_path__ + "static/media/LOGO CABANG DINAS-04.f3ea3659.png";